export default __webpack_public_path__ + "static/media/5-Learning.f2b21906.png";